import { render, staticRenderFns } from "./addSubMember.vue?vue&type=template&id=2b75e4d5&scoped=true&"
import script from "./addSubMember.vue?vue&type=script&lang=js&"
export * from "./addSubMember.vue?vue&type=script&lang=js&"
import style0 from "./addSubMember.vue?vue&type=style&index=0&id=2b75e4d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b75e4d5",
  null
  
)

export default component.exports